import { CanMatchFn } from '@angular/router';
import { inject } from '@angular/core';
import { Permissions as PermissionsService } from '@customer/services/permissions.svc';
import { Observable, Subscriber } from 'rxjs';

export const intrastatePipelines: CanMatchFn = () => {
  const permissionsSvc = inject(PermissionsService);
  const roleSvcFnChecks = ['hasPortalAdminRole', 'hasNGPUserRole', 'hasNGPBusinessSegment'] as const;
  const hasIntrastatePipelinesAccess$ = new Observable<boolean>((subscriber: Subscriber<boolean>) => {
    let isVerdict = false;
    for (const roleSvcFn of roleSvcFnChecks) {
      const permissionCheck = permissionsSvc[roleSvcFn] as (() => boolean) | undefined;
      if (permissionCheck?.call(permissionsSvc)) {
        isVerdict = true;
        break;
      }
    }
    subscriber.next(isVerdict);
    subscriber.complete();
  });
  return hasIntrastatePipelinesAccess$;
};
